import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import AuthService from "../../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";

class NewPassword extends Component {
  constructor(props) {
    super(props);
    if (!this.props.match.params.token || !this.props.match.params.email) {
      console.log("token or email not found");
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.Auth = new AuthService();
  }

  validatePasswordField(name, value) {
    if (value == null || value.length < 4) {
      return false;
    } else {
      if (
        name == "passwordConfirm" &&
        this.state.password &&
        value.length != this.state.password.length
      ) {
        return false;
      }
    }
    return true;
  }

  notifyError(err) {
    toast.error(err);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (!this.state || !this.state.password || !this.state.passwordConfirm) {
      this.notifyError(
        "Veuillez reessayer. Les informations entrées ne sont pas correctes ou manquantes."
      );
      return;
    }
    this.setState({ loading: true });
    this.Auth.httpRequest("POST", "passwordForgotten", {
      email: this.props.match.params.email,
      token: this.props.match.params.token,
      password: this.state.password
    })
      .then(res => {
        this.setState({ loading: false });
        this.props.history.replace("/redirected");
        this.notifySuccess(
          "Mot de passe changé ! Tu peux te connecter dès maintenant"
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        this.notifyError(err.toString());
      });
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
    if (e.target.name == "password") {
      if (this.validatePasswordField("password", e.target.value)) {
        this.setState({ passwordVerif: true });
      } else {
        this.setState({ passwordVerif: false });
      }
    } else {
      if (this.validatePasswordField("passwordConfirm", e.target.value)) {
        this.setState({ passwordConfirmVerif: true });
      } else {
        this.setState({ passwordConfirmVerif: false });
      }
    }
  }

  componentWillMount() {}

  componentDidMount() {
    this.setState({ passwordVerif: false, passwordConfirmVerif: false });
  }

  render() {
    let content, loading, style, styleConfirm;
    if (!this.state) {
      content = (
        <ContentLoader
          height={200}
          width={400}
          speed={2}
          primaryColor={"#f3f3f3"}
          secondaryColor={"#ecebeb"}
        >
          <rect x="7" y="17" rx="4" ry="4" width="126.36" height="11.14" />
          <rect x="11" y="33.9" rx="3" ry="3" width="107.1" height="11.26" />
          <rect x="3" y="58" rx="3" ry="3" width="385" height="28.48" />
          <rect x="3" y="95" rx="3" ry="3" width="385" height="28.48" />
          <rect x="9" y="143.9" rx="0" ry="0" width="105" height="24" />
          <rect x="310" y="153.9" rx="0" ry="0" width="78" height="9" />
        </ContentLoader>
      );
    } else {
      if (this.state.loading) {
        loading = (
          <img
            src="/img/loading_icon.gif"
            style={{
              height: "auto",
              width: "auto",
              maxWidth: 70 + "px",
              maxHeight: 70 + "px"
            }}
          />
        );
      }
      if (this.state.passwordVerif) {
        style = { borderColor: "green" };
      } else {
        style = { borderColor: "red" };
      }
      if (this.state.passwordConfirmVerif) {
        styleConfirm = { borderColor: "green" };
      } else {
        styleConfirm = { borderColor: "red" };
      }
      content = (
        <CardBody>
          <img
            alt=""
            src={
              "/img/logo-password.png"
            }
            className="mcnImage"
            width="420"
            height="200"
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
          />
          <br />
          <h5>Mot de passe oublié</h5>
          <p className="text-muted">Nouveau mot de passe</p>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fa fa-lock" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Nouveau mot de passe"
              name="password"
              type="password"
              id="password"
              onChange={this.handleChange}
              style={style}
              required
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="fa fa-lock" />
              </InputGroupText>
            </InputGroupAddon>
            <Input
              placeholder="Confirmation mot de passe"
              name="passwordConfirm"
              type="password"
              id="passwordConfirm"
              onChange={this.handleChange}
              style={styleConfirm}
              required
            />
          </InputGroup>
          <Row>
            <Col
              xs="6"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                display: "block"
              }}
            >
              <Button
                id="submit"
                color="primary"
                className="px-4"
                onClick={this.handleFormSubmit}
                block
              >
                Changer
              </Button>
              {loading}
            </Col>
          </Row>
        </CardBody>
      );
    }
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">{content}</Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default NewPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/NewPassword/NewPassword.js